<template>
  <div>
    <MinimalPresentationsList
      @logout="onLogout"
      @selectPresentation="onSelectPresentation"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MinimalPresentationsList from '../ms-teams/MSTeamsPresentationsList.vue'
import util from '@/util'

export default {
  components: {
    MinimalPresentationsList,
  },

  computed: {
    ...mapGetters('zoomApp', [
      'isZoomReady',
    ]),
  },
  methods: {
    ...mapActions('zoomApp', [
      'shareAppToParticipantsAction',
      'attachPresentationToZoomMeetingAction',
    ]),
    async onSelectPresentation(presentation) {
      this.$router.push({
        name: 'PresentationDetail',
        params: {
          id: presentation.id,
        },
        query: {
          presenting: true,
        },
      })
      if (!this.isZoomReady) {
        return
      }

      await this.attachPresentationToZoomMeetingAction(presentation)
      await this.shareAppToParticipantsAction()
    },
    onLogout() {
      util.logout()
    },
  },
}
</script>
